import { render, staticRenderFns } from "./DkoChangesCard.vue?vue&type=template&id=06c7f118"
import script from "./DkoChangesCard.vue?vue&type=script&lang=js"
export * from "./DkoChangesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports